import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ModalWrapper,
  Header,
  Title,
  CloseButton,
  Card,
  CardContent,
  Img,
  CardInfo,
  CardTitle,
  CardAddress,
  DetailsBtn
} from './styled';
import { palette } from '../../../../styles/_palette';
import CloseIcon from '../../../../public/static/images/item/close.svg';

interface Props {
  name: string;
  address?: string;
  coverUrl: string;
  url: string;
  onClose: () => void;
}

export const PashaProjectModal: React.FC<Props> = ({
  name,
  address,
  coverUrl,
  url,
  onClose
}) => {
  const { t } = useTranslation();
  return (
    <ModalWrapper>
      <Header>
        <Title>{name}</Title>
        <CloseButton
          aria-label="Close"
          role="button"
          onClick={onClose}
          data-cy="map-modal-close"
        >
          <CloseIcon fill={palette.heatheredGrey} width={15} height={15} />
        </CloseButton>
      </Header>
      <Card>
        <CardContent>
          <Img src={coverUrl} alt={name} />
          <CardInfo>
            <CardTitle>{name}</CardTitle>
            {address && <CardAddress>{address}</CardAddress>}
          </CardInfo>
        </CardContent>
        <DetailsBtn href={url} target="_blank" rel="noopener noreferrer">
          {t('pasha.details')}
        </DetailsBtn>
      </Card>
    </ModalWrapper>
  );
};
